import { Message } from "primereact/message";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MeaPage from "../../../components/MeaPage";
import { useAuthContext } from "../../../hooks/useAuthContext";
import trainingsAPI from "../../../services/trainings";
import { PERMISSION_TRAINING_SLOT_CHANGE_REQUESTS } from "../../../permissions";
import SlotChangeRequestsListComponent from "../../trainings/slot-change-requests/components/SlotChangeRequestsListComponent";
import SlotChangeProposalsComponent from "../../trainings/slot-change-requests/components/SlotChangeProposalsComponent";
import SecretariatWorkspaceBar from "../components/SecretariatWorkspaceBar";

const SecretariatSlotChangeRequestsDetailPage = () => {
  const { schoolId, trainingId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { auth, hasPermission } = useAuthContext();
  const isProposalsPage = location.pathname.endsWith("/proposals");
  const listPath = `/school/${schoolId}/secretariat/slot-change-requests/${trainingId}`;

  const trainingQuery = trainingsAPI.GetOne(schoolId, trainingId, auth?.access_token);
  const training = trainingQuery?.data?.data;

  const canList = hasPermission(PERMISSION_TRAINING_SLOT_CHANGE_REQUESTS.LIST);
  const canApply = hasPermission(PERMISSION_TRAINING_SLOT_CHANGE_REQUESTS.APPLY);

  return (
    <MeaPage
      title={isProposalsPage ? "Propositions d'affectation" : "Changements de créneau"}
      subtitle={
        isProposalsPage
          ? `Vérifiez les meilleures affectations puis approuvez les changements sélectionnés${training ? ` — ${training.name}` : ""}`
          : `Gérer les demandes de changement de classe sur un autre créneau du même niveau${training ? ` — ${training.name}` : ""}`
      }
      breadcrumb={
        <SecretariatWorkspaceBar
          section="slot-change-requests"
          training={training}
          trailing={isProposalsPage ? "Propositions d'affectation" : undefined}
        />
      }
      showBackButton={true}
      onBackButtonClick={() =>
        navigate(isProposalsPage ? listPath : `/school/${schoolId}/secretariat`)
      }
    >
      {!canList || (isProposalsPage && !canApply) ? (
        <Message
          severity="warn"
          text={
            isProposalsPage
              ? "Vous n'avez pas accès aux propositions de changement de créneau."
              : "Vous n'avez pas accès à la liste des demandes de changement de créneau."
          }
        />
      ) : isProposalsPage ? (
        <SlotChangeProposalsComponent />
      ) : (
        <SlotChangeRequestsListComponent
          schoolId={schoolId}
          trainingId={trainingId}
          showAddButton={true}
          showFilterButton={true}
          showFilter={true}
          proposalsPath={`${listPath}/proposals`}
        />
      )}
    </MeaPage>
  );
};

export default SecretariatSlotChangeRequestsDetailPage;
